var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCommitment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "88519383-3657-46CD-9134-B4FC529A56E3-523-00000CD003DF3512@1.5x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "portfolio-builder",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2.5b-client-profile-moneymind",
    transform: "translate(-284.000000, -315.000000)",
    fill: "#0068AE"
  }, /*#__PURE__*/React.createElement("g", {
    id: "work-area",
    transform: "translate(60.000000, 84.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "content"
  }, /*#__PURE__*/React.createElement("g", {
    id: "client-profile"
  }, /*#__PURE__*/React.createElement("g", {
    id: "clarence",
    transform: "translate(72.000000, 123.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "percentage",
    transform: "translate(0.000000, 73.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "commitment",
    transform: "translate(120.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "text",
    transform: "translate(6.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic/hc/commitment",
    transform: "translate(26.000000, 30.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9999661,1.58874497e-08 C24.8365305,1.58874497e-08 32.0000006,7.16343592 32.0000006,16.0000345 C32.0000006,24.8364963 24.8365305,31.9999322 15.9999661,31.9999322 C7.16343593,31.9999322 2.33581543e-08,24.8364963 2.33581543e-08,16.0000345 C2.33581543e-08,7.16343592 7.16343593,1.58874497e-08 15.9999661,1.58874497e-08 Z M15.9999426,6.54546258 C10.7783918,6.54546258 6.54545435,10.7783156 6.54545435,16.0000352 C6.54545435,21.2214806 10.7783918,25.4544602 15.9999426,25.4544602 C21.2215989,25.4544602 25.4545363,21.2214806 25.4545363,16.0000352 C25.4545363,10.7783156 21.2215989,6.54546258 15.9999426,6.54546258 Z M14.6976138,12.8862401 C15.4884952,11.3114794 16.5999199,9.60467537 18.5288616,9.66095163 C19.9375541,9.70348246 21.439685,10.5348991 21.6458817,12.0936888 C21.8702681,13.7895111 20.5425209,15.2446501 19.8486365,16.6744074 C18.9673254,18.4819822 18.3798153,20.4713311 18.0657476,22.4534801 C18.0845941,22.3423821 16.1063979,21.6580634 15.8792013,21.5664563 C13.3829094,20.5470982 9.37877472,18.8786505 9.38027144,15.6512675 C9.38027144,13.5963478 10.8990954,12.1470851 12.7816997,12.1470851 C12.9539299,12.1470851 14.8980832,12.4809317 14.6976138,12.8862401 Z",
    id: "ic_commitment"
  })))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCommitment);
export default __webpack_public_path__ + "static/media/ic_commitment.31faf8e09779b72f650c17046fcff17a.svg";
export { ForwardRef as ReactComponent };